module.exports = __webpack_public_path__ + "static/cs3-cdef03d3bc5b09f1040cd0021fe975fb.jpg";